"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var errors = _interopRequireWildcard(require("./errors-const"));

var _utils = require("../utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ReportsService {
  constructor(config) {
    if (config) {
      this.logger = config.logger || function () {};
    }
  }

  getReportsObject(promoVideoData) {
    if (!promoVideoData) {
      throw errors.PROMO_VIDEO_DATA_MISSING;
    }

    const decorationData = promoVideoData.decoration.decorationData;
    const {
      clips,
      reportDefaults
    } = promoVideoData;
    const reportObject = { ...reportDefaults,
      ...(0, _utils.getCaptionsPropsForReports)(decorationData),
      ...(0, _utils.getClipPropsForReports)(clips),
      isFreeToUse: !!promoVideoData.isFreeVideo
    };
    return reportObject;
  }

  setReportValue(key, value, reportDefaults) {
    if (!_.isString(key)) {
      throw errors.INVALID_PARMS;
    }

    if (!reportDefaults) {
      throw errors.PROMO_VIDEO_DATA_MISSING;
    }

    reportDefaults[key] = value;
    return reportDefaults;
  }

}

exports.default = ReportsService;